import { render, staticRenderFns } from "./VoucherImageCard.vue?vue&type=template&id=883ec6f6&scoped=true"
import script from "./VoucherImageCard.vue?vue&type=script&lang=js"
export * from "./VoucherImageCard.vue?vue&type=script&lang=js"
import style0 from "./VoucherImageCard.vue?vue&type=style&index=0&id=883ec6f6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "883ec6f6",
  null
  
)

export default component.exports